/** @file The strip rect of one tile of a facet entry on its sheet (along x, or down with `extendX`). */
import type { FacetEntry } from '@zilo/pose3d-format/types/facet';
import type { CellRect } from '@zilo/pose3d-export/types/bundle';

/** `[ox + t*w, oy, w, h]`, or `[ox, oy + t*h, w, h]` for the transposed `extendX` layout (18.5). */
export function cellRectOf(entry: Pick<FacetEntry, 'origin' | 'size' | 'extendX'>, tile: number): CellRect {
  const [ox, oy] = entry.origin;
  const [w, h] = entry.size;
  return entry.extendX === true ? [ox, oy + tile * h, w, h] : [ox + tile * w, oy, w, h];
}
